import {Component, Injector, OnDestroy, OnInit} from '@angular/core';
import {AddToListViewModel} from "@app/presentation/pages/add-to-list/add-to-list.view-model";
import {MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {routesNames} from "@app/app-routing.module";
import {Subscription} from "rxjs";
import {PopupDispatcher} from "@app/presentation/components/errors/popup.dispatcher";
import {ExitService} from "@app/presentation/services/exit.service";
import {DisplayService} from "@app/presentation/services/display.service";
import {List} from "@app/core/lists/domain/list";
import {Product} from "@app/core/product/domain/dtos/product";
import {ListActionModalService} from "@app/presentation/services/list-service/list-action-modal.service";
import {ModalService} from "@app/presentation/services/modal/modal.service";

@Component({
  selector: 'app-add-to-list',
  templateUrl: './add-to-list.component.html',
  styleUrls: ['./add-to-list.component.scss'],
  providers: [AddToListViewModel]
})
export class AddToListComponent implements OnInit, OnDestroy{

  product?: Product | null;

  listOfList$ = this.addToListViewModel.getAllLists();

  routesNames = routesNames;

  bottomSheetRef?: MatBottomSheetRef;

  successfullyAddedToList$ = this.addToListViewModel.successfullyAddedToList$;

  closeAddToListSubscription?: Subscription;

  isMobile$ = this.displayService.isMobileDisplay$;

  isDesktop$ = this.displayService.isDesktopDisplay$;

  isGetAllListLoading$ = this.addToListViewModel.isGetAllListLoading$

  returnUrl: string | null = null;

  constructor(
    private addToListViewModel: AddToListViewModel,
    private injector: Injector,
    private popupDispatcher: PopupDispatcher,
    private displayService: DisplayService,
    private listService: ListActionModalService,
  ) {
    this.popupDispatcher.setNotifier(this.addToListViewModel.notifier)
    const data = ModalService.getModalData(this.injector);
    this.product = data?.product;
    this.returnUrl = ExitService.getReturnUrl(this.injector);
  }

  ngOnInit(): void {
       this.closeAddToListSubscription = this.successfullyAddedToList$.subscribe({
            next: list => this.closeAddToList(list)
        });
  }

  ngOnDestroy(): void {
    this.closeAddToListSubscription?.unsubscribe();
  }

  addToList(listId: number) {
    if (this.product) {
      this.addToListViewModel.addProductToList(listId, this.product, 1);
    }
  }

  closeAddToList(list: List) {
    ExitService.exit(this.injector,list);
  }

  createNewList(): void {
    if (this.product == null) {
      return;
    }
    const productsCodes = [this.product.code];
    this.listService.openCreateList(productsCodes);
  }
}
